export default "__VITE_ASSET__BalxxvHV__"